import { alias } from '@ember/object/computed';
import EmberObject, { computed } from '@ember/object';

export default class XZoomAccuracyBase extends EmberObject {
  zoomSettings = null;
  ticksWithLimits = null;

  @alias('enclosingTicks.previousTick.value') previousTickValue;

  @alias('enclosingTicks.nextTick.value') nextTickValue;

  @computed('enclosingTicks.{nextTick.x,previousTick.x}') get pxBetweenTicks() {
    var previousTicksPosition = this.enclosingTicks.previousTick.x;
    var nextTicksPosition = this.enclosingTicks.nextTick.x;
    return nextTicksPosition - previousTicksPosition;
  }

  @computed('previousTickValue', 'nextTickValue') get valueDiffBetweenTicks() {
    var previousTickValue = this.previousTickValue;
    var nextTickValue = this.nextTickValue;
    var result = nextTickValue - previousTickValue;
    return Math.abs(result);
  }
}
